import { render, staticRenderFns } from "./ProductSort.vue?vue&type=template&id=4eb39298&scoped=true"
import script from "./ProductSort.vue?vue&type=script&lang=js"
export * from "./ProductSort.vue?vue&type=script&lang=js"
import style0 from "./ProductSort.vue?vue&type=style&index=0&id=4eb39298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb39298",
  null
  
)

export default component.exports